module.exports = __webpack_public_path__ + "img/header-weddingRingsWhitegold.b4b280c.webp";